import { Stack } from '@mui/material';
import { SectionLabel } from './EquipmentOptionStyled';
import PropTypes from 'prop-types';

// Hoisted out of the render: a fresh `sx` object literal per render defeats
// emotion's serialization cache, and an equipment row renders several Sections.
const ROOT_SX = { mt: 0.25 };
const LABEL_SX = { mt: 0.15 };
const CONTENT_SX = { flexWrap: 'wrap', rowGap: 0.25 };

const Section = ({ label, children }) => (
    <Stack direction="row" spacing={1} alignItems="center" sx={ROOT_SX}>
        <Stack flexShrink={0} flexGrow={0} sx={LABEL_SX}>
            <SectionLabel>{label}</SectionLabel>
        </Stack>
        <Stack direction="row" spacing={1} sx={CONTENT_SX}>
            {children}
        </Stack>
    </Stack>
);

Section.propTypes = {
    label: PropTypes.string,
    children: PropTypes.node,
};

export default Section;
